module.exports = __webpack_public_path__ + "img/check-square.1822539f.svg";